module.exports = __webpack_public_path__ + "static/img/drilling03.4afd9ca9.png";